import "./navbar.css";
import Button from "../../Custom/Button/Button";
import { useGlobalContext } from "../../../Context/Context";
import procenaRizikaImg from "../../../picture/procena-rizika.png";
import evidencijeObrasciImg from "../../../picture/evidencije-obrasci.png";
import poslovneJediniceImg from "../../../picture/poslovne-jedinice.png";
import sredstvaOpremaImg from "../../../picture/sredstva-oprema.png";
import dokumentaZaposlenihImg from "../../../picture/dokumenta-zaposlenih.png";
import zastitaOdPozaraImg from "../../../picture/zastita-od-pozara.png";
import zastitaZivSredineImg from "../../../picture/zastita-ziv-sredine.png";
import poslovniSaradniciImg from "../../../picture/poslovni-saradnici.png";
import ugovoriOdlukeImg from "../../../picture/ugovori-odluke.png";

const NAV_ITEMS = [
  { key: "PROCENA_RIZIKA",          img: procenaRizikaImg,       label: "ПРОЦЕНА РИЗИКА" },
  { key: "EVIDENCIJE_OBRASCI",      img: evidencijeObrasciImg,   label: "ЕВИДЕНЦИЈЕ И ОБРАСЦИ" },
  { key: "POSLOVNE_JEDINICE",       img: poslovneJediniceImg,    label: "ПОСЛОВНЕ ЈЕДИНИЦЕ" },
  { key: "SREDSTVA_OPREMA",         img: sredstvaOpremaImg,      label: "СРЕДСТВА И ОПРЕМА" },
  { key: "DOKUMENTA_ZAPOSLENIH",    img: dokumentaZaposlenihImg, label: "ДОКУМЕНТА ЗАПОСЛЕНИХ" },
  { key: "ZASTITA_OD_POZARA",       img: zastitaOdPozaraImg,     label: "ЗАШТИТА ОД ПОЖАРА" },
  { key: "ZASTITA_ZIVOTNE_SREDINE", img: zastitaZivSredineImg,   label: "ЗАШТИТА ЖИВ. СРЕДИНЕ" },
  { key: "POSLOVNI_SARADNICI",      img: poslovniSaradniciImg,   label: "ПОСЛОВНИ САРАДНИЦИ" },
  { key: "UGOVORI_ODLUKE",          img: ugovoriOdlukeImg,       label: "УГОВОРИ И ОДЛУКЕ" },
];

function NavbarDocuments({ setIsDocumentNavbar, selectedCompany }) {
  const {
    selectedNavbarDocument,
    setSelectedNavbarDocument,
    selectedEvidencija,
    setSelectedEvidencija,
  } = useGlobalContext();

  const handleClick = (key) => {
    if (selectedNavbarDocument === key) {
      setSelectedNavbarDocument("");
      setIsDocumentNavbar(false);
      if (selectedEvidencija) setSelectedEvidencija(0);
    } else {
      setSelectedNavbarDocument(key);
    }

    if (selectedEvidencija && key !== "EVIDENCIJA") setSelectedEvidencija(0);
  };

  return (
    <div className="wraper-user-location">
      {NAV_ITEMS.map(({ key, img, label }) => (
        <div
          key={key}
          onClick={() => handleClick(key)}
          className="div-documents-navbar"
        >
          <Button active={selectedNavbarDocument === key} activation={true}>
            <div className="navbar-btn-content">
              <img src={img} alt={label} />
              <div className="navbar-btn-label">{label}</div>
            </div>
          </Button>
        </div>
      ))}
    </div>
  );
}

export default NavbarDocuments;